import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { AssociarCondutorComponent, AferirDioComponent, DioComponent, FormDioComponent, ViewDioComponent, AssinaturaDioComponent, CancelarDioComponent, PrintDioComponent } from './';
import { UpdateAferidorComponent } from './view-dio/update-aferidor/update-aferidor.component';
import { NovaObservacaoDialogComponent } from './view-dio/nova-observacao-dialog/nova-observacao-dialog.component';
import { ApontamentosModule } from '../apontamentos/apontamentos.module';
import { RegistrarApontamentoComponent } from './aferir-dio/registrar-apontamento/registrar-apontamento.component';
import { DioExistenteDialog } from './form-dio/form-dio.component';

@NgModule({
    declarations: [
        AferirDioComponent,
        AssinaturaDioComponent,
        AssociarCondutorComponent,
        UpdateAferidorComponent,
        NovaObservacaoDialogComponent,
        CancelarDioComponent,
        DioComponent,
        DioExistenteDialog,
        FormDioComponent,
        PrintDioComponent,
        ViewDioComponent,
        RegistrarApontamentoComponent,
    ],
    imports: [
        SharedModule,
        GoogleMapsModule,
        ApontamentosModule,
    ],
    exports: [DioComponent]
})
export class DioModule { }
